import { Component, OnInit, Input } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-bg-section',
  templateUrl: './bg-section.component.html',
  styleUrls: ['./bg-section.component.scss']
})
export class BgSectionComponent implements OnInit {



  @Input() title: string;
  @Input() description: string;
  @Input() ctaText: string;
  @Input() ctaLink: string;
  @Input() bgUrl: string;

  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit() {
  }
  
  sanitizeImageUrl(imageUrl: string): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(imageUrl);
}
}
